import Reveal from "../Reveal";
import JourneyPath from "../JourneyPath";
import { IMAGES, CONTACTS } from "../../data/content";

export default function About() {
    return (
        <section id="about" className="section-pad" data-testid="about-section">
            <div className="container-luxe">
                <div className="grid gap-14 lg:grid-cols-12 lg:gap-10 items-center">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <p className="eyebrow mb-5">About Us</p>
                            <h2 className="font-serif text-navy text-3xl sm:text-4xl leading-snug">
                                We don&rsquo;t just show you a destination — we help you{" "}
                                <span className="italic text-gold">feel it, live it,</span> and{" "}
                                <span className="italic text-gold">carry it home.</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.15}>
                            <div className="h-px w-16 bg-gold/60 my-7" />
                            <p className="font-light leading-relaxed">
                                Journeys Unscripted is a boutique travel house crafting private and small-group journeys
                                from India. Every itinerary begins with a conversation, not a catalogue — because the way
                                you like to travel is the only brief we need.
                            </p>
                        </Reveal>
                        <Reveal delay={0.25} className="mt-9 space-y-5">
                            {CONTACTS.map((c) => (
                                <div key={c.name} className="flex items-center gap-4" data-testid="founder-card">
                                    <span className="flex items-center justify-center h-11 w-11 rounded-full border border-gold/60 font-serif italic text-gold text-lg shrink-0">
                                        {c.initial}
                                    </span>
                                    <div>
                                        <p className="font-serif text-navy text-lg leading-tight">{c.fullName}</p>
                                        <p className="text-xs tracking-[0.14em] uppercase text-stone/70 mt-0.5">{c.role}</p>
                                    </div>
                                </div>
                            ))}
                            <p className="text-sm font-light leading-relaxed text-stone/85 pt-1">
                                Two enthusiastic travellers who understand the anxiety of exploring a new place for the
                                first time — and share real, lived experiences to put you at ease.
                            </p>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-7">
                        <Reveal delay={0.1} className="relative">
                            <div className="absolute -top-4 -right-4 sm:-top-6 sm:-right-6 h-full w-full border border-gold/50" aria-hidden="true" />
                            <img
                                src={IMAGES.about.src}
                                alt={IMAGES.about.alt}
                                loading="lazy"
                                className="relative w-full h-[320px] sm:h-[440px] object-cover"
                                data-testid="about-image"
                            />
                            <p className="mt-6 text-xs tracking-[0.2em] uppercase text-stone/60">
                                Replace this photograph with your own — placeholder imagery
                            </p>
                        </Reveal>
                    </div>
                </div>

                <JourneyPath className="mt-20 sm:mt-24" />
            </div>
        </section>
    );
}
